import React, { useState, useEffect } from "react";
import { themeStyle, themeStyleDark } from "./Components";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { Up, Down, Left, Right } from "../components/PositionFade";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useSpring, useSprings, useScroll, animated } from "@react-spring/web";
import { useNavigate } from "react-router";
import {
  LeftInView,
  RightInView,
  UpInView,
  DownInView,
} from "./PositionFadeInView";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import DataObjectIcon from "@mui/icons-material/DataObject";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  useSpringCarousel,
  useTransitionCarousel,
} from "react-spring-carousel";
import {
  Box,
  Container,
  Typography,
  Checkbox,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

export function YouWillGet(props) {
  const state = useSelector((state) => state);

  return (
    <div
      style={{
        filter: props.invert ? "invert(1)" : "invert(0)",
        width: "100vw",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "40px",
        backgroundColor: "#111",
        paddingBottom: "100px",
        paddingTop: "100px",
      }}
    >
      <Grid container alignItems="center" justifyContent={"space-between"}>
        <Grid
          item
          xs={12}
          md={6}
          lg={3}
          style={{
            fontSize: state.auth.isMobile ? "30px" : "40px",
            fontWeight: 600,
            color: "white",
          }}
        >
          You will get
        </Grid>
        <Grid item xs={12} md={6} lg={1}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div
              className="anigrad"
              style={{
                padding: "20px",
                backgroundColor: themeStyle.primaryColor,
                borderRadius: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AppRegistrationIcon
                style={{ fontSize: "50px", color: "white" }}
              />
            </div>
            <div
              style={{ fontSize: "20px", color: "white", marginTop: "10px" }}
            >
              {props.title1}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6} lg={1}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div
              className="anigrad"
              style={{
                padding: "20px",
                backgroundColor: themeStyle.primaryColor,
                borderRadius: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AccountTreeIcon style={{ fontSize: "50px", color: "white" }} />
            </div>
            <div
              style={{ fontSize: "20px", color: "white", marginTop: "10px" }}
            >
              {props.title2}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6} lg={1}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div
              className="anigrad"
              style={{
                padding: "20px",
                backgroundColor: themeStyle.primaryColor,
                borderRadius: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <DataObjectIcon style={{ fontSize: "50px", color: "white" }} />
            </div>
            <div
              style={{ fontSize: "20px", color: "white", marginTop: "10px" }}
            >
              {props.title3}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6} lg={1}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div
              className="anigrad"
              style={{
                padding: "20px",
                backgroundColor: themeStyle.primaryColor,
                borderRadius: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <AutoGraphIcon style={{ fontSize: "50px", color: "white" }} />
            </div>
            <div
              style={{ fontSize: "20px", color: "white", marginTop: "10px" }}
            >
              {props.title4}
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6} lg={1}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div
              className="anigrad"
              style={{
                padding: "20px",
                backgroundColor: themeStyle.primaryColor,
                borderRadius: "60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <EqualizerIcon style={{ fontSize: "50px", color: "white" }} />
            </div>
            <div
              style={{ fontSize: "20px", color: "white", marginTop: "10px" }}
            >
              {props.title5}
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export function Advantages(props) {
  const state = useSelector((state) => state);

  return (
    <div
      style={{
        // filter: props.invert ? "invert(1)" : "invert(0)",
        width: "100vw",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: state.auth.isMobile ? "0px" : "150px",
        backgroundColor: "#111",
      }}
    >
      <div
        className="anigrad"
        style={{
          width: "100%",
          backgroundColor: "#ddd",
          borderRadius: state.auth.isMobile ? "0px" : "50px",
          textAlign: "center",
          fontWeight: 600,
          fontSize: "50px",
          color: "white",
          padding: state.auth.isMobile ? "20px" : "100px",
        }}
      >
        {props.title}
        <br />
        <br />
        <Grid
          container
          alignItems="center"
          justifyContent={"space-between"}
          spacing={3}
        >
          <Grid
            item
            xs={12}
            md={6}
            style={{
              borderLeft: "2px solid #bbb",
              padding: "15px",
              paddingLeft: "30px",
              fontSize: "30px",
              fontWeight: 600,
              color: "white",
              textAlign: "left",
            }}
          >
            {props.title1}
            <div
              style={{
                marginTop: "15px",
                fontSize: "20px",
                color: "white",
                fontWeight: "normal",
                lineHeight: "25px",
              }}
            >
              {props.subtitle1}
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            style={{
              borderLeft: "2px solid #bbb",
              padding: "15px",
              paddingLeft: "30px",
              fontSize: "30px",
              fontWeight: 600,
              color: "white",
              textAlign: "left",
            }}
          >
            {props.title2}
            <div
              style={{
                marginTop: "15px",
                fontSize: "20px",
                color: "white",
                fontWeight: "normal",
                lineHeight: "25px",
              }}
            >
              {props.subtitle2}
            </div>
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          alignItems="center"
          justifyContent={"space-between"}
          spacing={3}
        >
          <Grid
            item
            xs={12}
            md={6}
            style={{
              borderLeft: "2px solid #bbb",
              padding: "15px",
              paddingLeft: "30px",
              fontSize: "30px",
              fontWeight: 600,
              color: "white",
              textAlign: "left",
            }}
          >
            {props.title3}
            <div
              style={{
                marginTop: "15px",
                fontSize: "20px",
                color: "white",
                fontWeight: "normal",
                lineHeight: "25px",
              }}
            >
              {props.subtitle3}
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            style={{
              borderLeft: "2px solid #bbb",
              padding: "15px",
              paddingLeft: "30px",
              fontSize: "30px",
              fontWeight: 600,
              color: "white",
              textAlign: "left",
            }}
          >
            {props.title4}
            <div
              style={{
                marginTop: "15px",
                fontSize: "20px",
                color: "white",
                fontWeight: "normal",
                lineHeight: "25px",
              }}
            >
              {props.subtitle4}
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export function OurProcess(props) {
  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(false);
  const [expanded4, setExpanded4] = useState(false);
  const state = useSelector((state) => state);

  return (
    <div
      style={{
        filter: props.invert ? "invert(1)" : "invert(0)",
        width: "100vw",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: state.auth.isMobile ? "10px" : "150px",
        backgroundColor: "#111",
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent={"space-between"}
        spacing={10}
      >
        <Grid
          item
          xs={12}
          md={3}
          style={{
            fontSize: state.auth.isMobile ? "30px" : "40px",
            fontWeight: 600,
            color: "white",
            textAlign: "left",
          }}
        >
          Our process
          <div
            style={{ fontSize: "20px", color: "#bbb", fontWeight: "lighter" }}
          >
            We work in smaller phases, gather feedback at each, and iterate on
            our ideas. This is our proven method for creating world-class
            products, that convert and win hearts.
          </div>
        </Grid>
        <Grid item xs={12} md={6} lg={9}>
          <Accordion
            expanded={expanded1}
            onClick={() => {
              setExpanded1(!expanded1);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: "50px",
                color: "white",
                fontSize: state.auth.isMobile ? "18px" : "28px",
                textAlign: "left",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              {props.step1}
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
                fontSize: "20px",
              }}
            >
              {props.step1description}
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded2}
            onClick={() => {
              setExpanded2(!expanded2);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: "50px",
                textAlign: "left",
                color: "white",
                fontSize: state.auth.isMobile ? "18px" : "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              {props.step2}
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
                fontSize: "20px",
              }}
            >
              {props.step2description}
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded3}
            onClick={() => {
              setExpanded3(!expanded3);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                textAlign: "left",
                height: "50px",
                color: "white",
                fontSize: state.auth.isMobile ? "18px" : "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              {props.step3}
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
                fontSize: "20px",
              }}
            >
              {props.step3description}
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded4}
            onClick={() => {
              setExpanded4(!expanded4);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: state.auth.isMobile
                  ? "5px 15px 25px 15px"
                  : "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                textAlign: "left",
                height: "50px",
                color: "white",
                fontSize: state.auth.isMobile ? "18px" : "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              {props.step4}
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
                fontSize: "20px",
              }}
            >
              {props.step4description}
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </div>
  );
}

export function FAQ(props) {
  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(false);
  const [expanded4, setExpanded4] = useState(false);
  const [expanded5, setExpanded5] = useState(false);
  const [expanded6, setExpanded6] = useState(false);
  const state = useSelector((state) => state);

  return (
    <div
      style={{
        filter: props.invert ? "invert(1)" : "invert(0)",
        width: "100vw",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "150px",
        backgroundColor: "#111",
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent={"space-between"}
        spacing={10}
      >
        <Grid
          item
          xs={12}
          md={3}
          style={{
            fontSize: state.auth.isMobile ? "30px" : "40px",
            fontWeight: 600,
            color: "white",
            textAlign: "left",
          }}
        >
          All the A's to your Q's
          <div
            style={{ fontSize: "20px", color: "#bbb", fontWeight: "lighter" }}
          >
            You have questions? We have answers!
          </div>
        </Grid>
        <Grid item xs={12} md={6} lg={9}>
          <Accordion
            expanded={expanded1}
            onClick={() => {
              setExpanded1(!expanded1);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: "50px",
                color: "white",
                fontSize: "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              1. What is digital marketing?
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Digital marketing refers to all marketing efforts that use the
              internet or electronic devices to reach and engage with consumers.
              It includes channels like search engines, social media, email, and
              websites to promote products or services, build brand awareness,
              and drive conversions.
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded2}
            onClick={() => {
              setExpanded2(!expanded2);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: "50px",
                color: "white",
                fontSize: "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              2. Why should I invest in digital marketing?
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Digital marketing offers numerous benefits, including
              cost-effectiveness, precise targeting, measurable results, and the
              ability to reach a global audience. Unlike traditional marketing,
              digital strategies can be quickly adjusted based on performance
              data, making them more efficient and flexible.
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded3}
            onClick={() => {
              setExpanded3(!expanded3);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: "50px",
                color: "white",
                fontSize: "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              3. What are the most common digital marketing strategies?
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Some of the most common strategies include:
              <ul>
                <li>
                  <b>Search Engine Optimization (SEO)</b> - Improving website
                  visibility on search engines like Google.
                </li>
                <li>
                  <b>Pay-Per-Click (PPC)</b> – Running paid ads that appear in
                  search results or on websites.
                </li>
                <li>
                  <b>Social Media Marketing</b> – Engaging users on platforms
                  like Facebook, Instagram, and LinkedIn.
                </li>
                <li>
                  <b>Email Marketing</b> – Directly reaching customers with
                  personalized email campaigns.
                </li>
                <li>
                  <b>Content Marketing</b> – Creating valuable content (blogs,
                  videos, infographics) to engage and inform your audience.
                </li>
              </ul>{" "}
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded4}
            onClick={() => {
              setExpanded4(!expanded4);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: "50px",
                color: "white",
                fontSize: "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              4. How do I know if my digital marketing efforts are working?
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              You can track the success of your digital marketing efforts
              through key performance indicators (KPIs) like website traffic,
              click-through rates, conversion rates, and customer engagement.
              Tools like Google Analytics and social media insights help measure
              these metrics and make data-driven decisions.
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded5}
            onClick={() => {
              setExpanded5(!expanded5);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: "50px",
                color: "white",
                fontSize: "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              5. What is SEO and why is it important?
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              SEO (Search Engine Optimization) is the practice of optimizing
              your website to rank higher in search engine results, making it
              easier for users to find you. It’s important because higher search
              rankings lead to more visibility, traffic, and potential
              customers, ultimately increasing business revenue.
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded6}
            onClick={() => {
              setExpanded6(!expanded6);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: "50px",
                color: "white",
                fontSize: "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              6. How can I reach my audience through digital marketing?
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Reaching your target audience involves using precise targeting
              methods. By leveraging tools like <b>Google Ads</b> for
              keyword-based targeting, social media platforms for demographic
              and interest-based targeting, and email marketing for personalized
              campaigns, you can connect with specific groups who are more
              likely to engage with your brand.
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </div>
  );
}

export function FAQSoft(props) {
  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [expanded3, setExpanded3] = useState(false);
  const [expanded4, setExpanded4] = useState(false);
  const [expanded5, setExpanded5] = useState(false);
  const [expanded6, setExpanded6] = useState(false);
  const state = useSelector((state) => state);

  return (
    <div
      style={{
        filter: props.invert ? "invert(1)" : "invert(0)",
        width: "100vw",
        height: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "150px",
        backgroundColor: "#111",
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent={"space-between"}
        spacing={10}
      >
        <Grid
          item
          xs={12}
          md={3}
          style={{
            fontSize: state.auth.isMobile ? "30px" : "40px",
            fontWeight: 600,
            color: "white",
            textAlign: "left",
          }}
        >
          All the A's to your Q's
          <div
            style={{ fontSize: "20px", color: "#bbb", fontWeight: "lighter" }}
          >
            You have questions? We have answers!
          </div>
        </Grid>
        <Grid item xs={12} md={6} lg={9}>
          <Accordion
            expanded={expanded1}
            onClick={() => {
              setExpanded1(!expanded1);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: "50px",
                color: "white",
                fontSize: "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              What is software development?
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Software development is the process of designing, creating,
              testing, and maintaining software applications or systems. It
              involves various stages such as planning, coding, debugging,
              deployment, and ongoing maintenance.
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded2}
            onClick={() => {
              setExpanded2(!expanded2);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: "50px",
                color: "white",
                fontSize: "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              What languages do you use in development?
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Common programming languages include Python, Java, JavaScript,
              C++, C#, Ruby, PHP, and Swift, among others. The choice of
              language depends on the project requirements, platform, and
              functionality.
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded3}
            onClick={() => {
              setExpanded3(!expanded3);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: "50px",
                color: "white",
                fontSize: "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              What is the software development lifecycle (SDLC)?{" "}
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              <li>
                <strong>Requirement gathering:</strong> Collecting business and
                technical requirements.
              </li>
              <li>
                <strong>System design:</strong> Designing architecture, user
                interfaces, and databases.
              </li>
              <li>
                <strong>Development:</strong> Writing and coding the software
                application.
              </li>
              <li>
                <strong>Testing:</strong> Identifying and fixing bugs and issues
                to ensure quality.
              </li>
              <li>
                <strong>Deployment:</strong> Deploying the software for users or
                customers.
              </li>
              <li>
                <strong>Maintenance:</strong> Updating and improving the
                software after launch.
              </li>
            </AccordionDetails>
          </Accordion>

          <Accordion
            expanded={expanded4}
            onClick={() => {
              setExpanded4(!expanded4);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: "50px",
                color: "white",
                fontSize: "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              What are the different types of software development?{" "}
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              <ul>
                <li>
                  <strong>Web Development:</strong> Building applications that
                  run on web browsers.
                </li>
                <li>
                  <strong>Mobile Development:</strong> Creating applications for
                  mobile devices (iOS, Android).
                </li>
                <li>
                  <strong>Desktop Development:</strong> Designing software for
                  computers (Windows, Mac, Linux).
                </li>
                <li>
                  <strong>Game Development:</strong> Developing interactive
                  games.
                </li>
                <li>
                  <strong>Embedded Systems Development:</strong> Programming
                  hardware devices with software.
                </li>
              </ul>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded5}
            onClick={() => {
              setExpanded5(!expanded5);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: "50px",
                color: "white",
                fontSize: "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              What is Agile software development?
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              Agile is a methodology that emphasizes iterative development,
              collaboration, and flexibility. It focuses on delivering small,
              incremental improvements to software in short cycles called
              "sprints" and adjusting the development process based on feedback.
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded6}
            onClick={() => {
              setExpanded6(!expanded6);
            }}
            style={{
              marginTop: "30px",
              borderRadius: "15px",
              width: "100%",
            }}
          >
            <AccordionSummary
              style={{
                padding: "5px 15px 5px 15px",
                backgroundColor: "#111",
                borderRadius: "5px",
                fontWeight: 600,
                height: "50px",
                color: "white",
                fontSize: "28px",
                alignItems: "center",
                borderBottom: "2px solid white",
              }}
              expandIcon={
                <ExpandMoreIcon style={{ fontSize: "30px", color: "white" }} />
              }
            >
              How long does it take to develop software?
            </AccordionSummary>

            <AccordionDetails
              style={{
                backgroundColor: "#111",
                color: "white",
                textAlign: "left",
              }}
            >
              The time required to develop software depends on factors such as
              the complexity of the project, the team size, the technology
              stack, and the scope of the requirements. Simple applications may
              take a few weeks, while larger systems can take several months or
              even years to develop fully.
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </div>
  );
}

export function Collage(props) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        padding: "150px",
        backgroundColor: props.invert ? "white" : "#111",
        marginBottom: "125vh",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: "10%",
          width: "30vh",
          height: "30vh",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundImage:
            "url('https://images.unsplash.com/photo-1719937206255-cc337bccfc7d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          left: "20%",
          marginTop: "10vh",
          width: "50vh",
          height: "50vh",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundImage:
            "url('https://images.unsplash.com/photo-1497366811353-6870744d04b2?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          left: "50%",
          marginTop: "-10vh",
          width: "80vh",
          height: "80vh",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundImage:
            "url('https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8b2ZmaWNlfGVufDB8fDB8fHww')",
        }}
      ></div>

      <div
        style={{
          position: "absolute",
          left: "10%",
          width: "40vh",
          height: "40vh",
          marginTop: "50vh",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundImage:
            "url('https://images.unsplash.com/photo-1551434678-e076c223a692?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          left: "35%",
          marginTop: "40vh",
          width: "100vh",
          height: "100vh",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundImage:
            "url(https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)",
        }}
      ></div>
      <div
        style={{
          position: "absolute",
          left: "15%",
          marginTop: "10vh",
          width: "60vh",
          height: "60vh",
          marginTop: "70vh",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundImage:
            "url('https://images.unsplash.com/photo-1516321318423-f06f85e504b3?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        }}
      ></div>
    </div>
  );
}

export function Marquee(props) {
  return (
    <div
      style={{
        width: "100vw",
        backgroundColor: props.invert ? "white" : "#111",
      }}
    >
      <marquee>
        <div
          style={{
            display: "flex",
            fontSize: "50px",
            color: props.invert ? "black" : "white",
            display: "flex",
          }}
        >
          <div style={{ marginLeft: "50px" }}>+ Paid Ads and Monetization</div>
          <div style={{ marginLeft: "50px" }}>+ SEO and Social</div>
          <div style={{ marginLeft: "50px" }}>+ Analytics and data</div>
          <div style={{ marginLeft: "50px" }}>+ Content creation</div>
        </div>
      </marquee>
      <marquee direction={"right"}>
        <div
          style={{
            display: "flex",
            fontSize: "50px",
            color: props.invert ? "black" : "white",
            display: "flex",
          }}
        >
          <div style={{ marginLeft: "50px" }}>+ Web design</div>
          <div style={{ marginLeft: "50px" }}>
            + Mobile Application Development
          </div>
          <div style={{ marginLeft: "50px" }}>+ Software Development</div>
          <div style={{ marginLeft: "50px" }}>+ E-Commerce</div>
          <div style={{ marginLeft: "50px" }}>+ UI/UX Development</div>
        </div>
      </marquee>
    </div>
  );
}

export function Collage2() {
  return (
    <div className="grid" style={{ height: "100vh" }}>
      <div className="grid-item1"></div>
      <div className="grid-item2"></div>
      <div className="grid-item3"></div>
      <div className="grid-item4"></div>
      <div className="grid-item5"></div>
      <div className="grid-item6"></div>
      <div className="grid-item7"></div>
      <div className="grid-item8"></div>
    </div>
  );
}

export function Trust(props) {
  const { carouselFragment, slideToPrevItem, slideToNextItem } =
    useSpringCarousel({
      withLoop: true,
      items: [
        {
          id: "item-1",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/t1.png")} />
            </div>
          ),
        },
        {
          id: "item-2",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/t2.png")} />
            </div>
          ),
        },
        {
          id: "item-3",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/t3.png")} />
            </div>
          ),
        },
        {
          id: "item-4",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/t4.jpg")} />
            </div>
          ),
        },
        {
          id: "item-5",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/t5.png")} />
            </div>
          ),
        },
        {
          id: "item-6",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/t6.png")} />
            </div>
          ),
        },
        {
          id: "item-7",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/t7.png")} />
            </div>
          ),
        },
        {
          id: "item-8",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/t8.jpg")} />
            </div>
          ),
        },
        {
          id: "item-9",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/t9.png")} />
            </div>
          ),
        },
      ],
    });

  useEffect(() => {
    const timer = setInterval(() => {
      slideToNextItem();
    }, 2000);
    return () => {
      window.clearInterval(timer);
    };
  }, [slideToNextItem]);

  return (
    <div>
      <div
        style={{
          color: props.invert ? "white" : "black",
          fontSize: "35px",
          fontWeight: 600,
        }}
      >
        Trusted by 100+ companies across the world.
      </div>
      <div
        style={{
          marginLeft: "500px",
          width: "20vw",
          height: "30vh",
          marginBottom: "100px",
        }}
      >
        {carouselFragment}
      </div>
    </div>
  );
}

export function Platforms(props) {
  const { carouselFragment, slideToPrevItem, slideToNextItem } =
    useSpringCarousel({
      withLoop: true,
      items: [
        {
          id: "item-1",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/p1.png")} />
            </div>
          ),
        },
        {
          id: "item-2",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/p2.jpg")} />
            </div>
          ),
        },
        {
          id: "item-3",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/p3.jpg")} />
            </div>
          ),
        },
        {
          id: "item-4",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/p4.png")} />
            </div>
          ),
        },
        {
          id: "item-5",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/p5.png")} />
            </div>
          ),
        },
        {
          id: "item-6",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/p6.png")} />
            </div>
          ),
        },
        {
          id: "item-7",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/p7.png")} />
            </div>
          ),
        },
        {
          id: "item-8",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/p8.png")} />
            </div>
          ),
        },
        {
          id: "item-9",
          renderItem: (
            <div
              className="trust a"
              style={{
                height: "100%",
                width: "100%",
                margin: "15px",
                borderRadius: 15,
                backgroundColor: "white",
                textAlign: "left",
                textAlign: "left",
                padding: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img style={{ width: "75%" }} src={require("../img/p9.png")} />
            </div>
          ),
        },
      ],
    });

  useEffect(() => {
    const timer = setInterval(() => {
      slideToNextItem();
    }, 2000);
    return () => {
      window.clearInterval(timer);
    };
  }, [slideToNextItem]);

  return (
    <div>
      <h1 style={{ color: props.invert ? "white" : "black", fontSize: "50px" }}>
        Platforms We Manage
      </h1>
      <div
        style={{
          marginLeft: "500px",
          width: "20vw",
          height: "30vh",
          marginBottom: "100px",
        }}
      >
        {carouselFragment}
      </div>
    </div>
  );
}

export function Tailor(props) {
  return (
    <Grid
      container
      spacing={4}
      justifyContent="space-between"
      style={{
        marginTop: "25px",
        marginBottom: "-25px",
        filter: props.invert ? "invert(1)" : "invert(0)",
      }}
    >
      <Grid item xs={12} md={4}>
        <div
          style={{
            width: "100%",
            height: "100%",
            border: "1px solid grey",
            borderRadius: "5px",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            justifyContent: "center",
            padding: "20px",
            paddingTop: "0px",
          }}
        >
          <h2>{props.title1}</h2>
          <div
            style={{
              fontSize: "20px",
              textAlign: "left",
              marginTop: "-15px",
            }}
          >
            {" "}
            {props.subtitle1}
          </div>
        </div>
      </Grid>
      <Grid item xs={12} md={4}>
        <div
          style={{
            width: "100%",
            height: "100%",
            border: "1px solid grey",
            borderRadius: "5px",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            justifyContent: "center",
            padding: "20px",
            paddingTop: "0px",
          }}
        >
          <h2>{props.title2}</h2>
          <div
            style={{
              fontSize: "20px",
              textAlign: "left",
              marginTop: "-15px",
            }}
          >
            {" "}
            {props.subtitle2}
          </div>
        </div>
      </Grid>
      <Grid item xs={12} md={4}>
        <div
          style={{
            width: "100%",
            height: "100%",
            border: "1px solid grey",
            borderRadius: "5px",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            justifyContent: "center",
            padding: "20px",
            paddingTop: "0px",
          }}
        >
          <h2>{props.title3}</h2>
          <div
            style={{
              fontSize: "20px",
              textAlign: "left",
              marginTop: "-15px",
            }}
          >
            {" "}
            {props.subtitle3}
          </div>
        </div>
      </Grid>
    </Grid>
  );
}

export const Features = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Safely handle features prop - ensure it's an array
  const features = Array.isArray(props.features) ? props.features : [];

  return (
    <Container sx={{ py: 8 }}>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          fontWeight: 600,
          mb: 4,
          fontFamily: "Montserrat",
          marginBottom: "50px",
          color: themeStyle.primaryColor,
        }}
      >
        Features and Advantages
      </Typography>
      <Grid container justifyContent="center">
        <Grid item key={1} xs={12} sm={6} md={3}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              boxShadow: 3,
              backgroundColor: themeStyle.primaryColor,
            }}
          >
            <CardContent sx={{ flexGrow: 1 }}>
              <Typography
                variant="h5"
                align="center"
                sx={{ fontWeight: 600, mb: 2 }}
              >
                {""}
              </Typography>
              <Typography
                variant="h4"
                align="center"
                sx={{ fontWeight: 600, mb: 4, color: "primary.main" }}
              >
                {""}
              </Typography>
              <Box style={{ marginTop: "60px" }}>
                {features.map((feature, i) => (
                  <Box
                    key={i}
                    sx={{
                      color: "white",
                      mb: 6,
                    }}
                  >
                    {feature}
                  </Box>
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item key={2} xs={12} sm={6} md={3}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              boxShadow: 3,
              backgroundColor: "#ddb6b2",
            }}
          >
            <CardContent sx={{ flexGrow: 1 }}>
              <div
                style={{
                  borderBottom: "2px solid grey",
                  paddingBottom: "15px",
                  marginBottom: "15px",
                  fontWeight: 600,
                }}
              >
                {props.plans[0].name}
              </div>

              <Box
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItmes: "center",
                  flexDirection: "column",
                }}
              >
                {features.map((feature, i) => (
                  <Box
                    key={i}
                    sx={{
                      mb: 2,
                      paddingBottom: "15px",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    {props.plans[0].features[i] ? (
                      <CheckCircleIcon
                        sx={{ color: "success.main", mr: 1, fontSize: "40px" }}
                      />
                    ) : (
                      <CancelIcon
                        sx={{ color: "error.main", mr: 1, fontSize: "40px" }}
                      />
                    )}
                  </Box>
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item key={2} xs={12} sm={6} md={3}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              boxShadow: 3,
              backgroundColor: "#e8cecc",
            }}
          >
            <CardContent sx={{ flexGrow: 1 }}>
              <div
                style={{
                  borderBottom: "2px solid grey",
                  paddingBottom: "15px",
                  marginBottom: "15px",
                  fontWeight: 600,
                }}
              >
                {props.plans[1].name}
              </div>

              <Box
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItmes: "center",
                  flexDirection: "column",
                }}
              >
                {features.map((feature, i) => (
                  <Box
                    key={i}
                    sx={{
                      mb: 2,
                      paddingBottom: "15px",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    {props.plans[1].features[i] ? (
                      <CheckCircleIcon
                        sx={{ color: "success.main", mr: 1, fontSize: "40px" }}
                      />
                    ) : (
                      <CancelIcon
                        sx={{ color: "error.main", mr: 1, fontSize: "40px" }}
                      />
                    )}
                  </Box>
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item key={2} xs={12} sm={6} md={3}>
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              boxShadow: 3,
              backgroundColor: "#f3e6e5",
            }}
          >
            <CardContent sx={{ flexGrow: 1 }}>
              <div
                style={{
                  borderBottom: "2px solid grey",
                  paddingBottom: "15px",
                  marginBottom: "15px",
                  fontWeight: 600,
                }}
              >
                {props.plans[2].name}
              </div>

              <Box
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItmes: "center",
                  flexDirection: "column",
                }}
              >
                {features.map((feature, i) => (
                  <Box
                    key={i}
                    sx={{
                      mb: 2,
                      paddingBottom: "15px",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    {props.plans[2].features[i] ? (
                      <CheckCircleIcon
                        sx={{ color: "success.main", mr: 1, fontSize: "40px" }}
                      />
                    ) : (
                      <CancelIcon
                        sx={{ color: "error.main", mr: 1, fontSize: "40px" }}
                      />
                    )}
                  </Box>
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};
